import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { verifierMdp, modifierMdp } from '../../App_Code/API';
import { estMotdePasseValide } from '../../App_Code/Utils';
import { MDP_TAILLE_MIN, MDP_TAILLE_MAX } from '../../App_Data/Consts';
import { AfficherFeedback, Texte } from '../ChampFormulaire';
import Card from '../Card';

class PageChangerMdp extends Component {
    constructor(props) {
        super(props);

        this.inputMdpActuel = React.createRef();
        this.inputNouveauMdp = React.createRef();
        this.inputConfirmationMdp = React.createRef();
        this.boutonSuivant = React.createRef();

        this.state = {
            peutModifier: false,
            MdpActuel: undefined,
        };
    }

    componentWillUnmount() {
        if (this.unblock) this.unblock();
    }

    VerifierValidation = (submittedValues) => {
        const { Mdp } = submittedValues;
        const { inputMdpActuel } = this;
        this.boutonSuivant.current.disabled = true;

        verifierMdp(Mdp).then((estMdpActuel) => {
            AfficherFeedback(inputMdpActuel, estMdpActuel);
            this.boutonSuivant.current.disabled = false;
            this.setState({ peutModifier: estMdpActuel, MdpActuel: Mdp });
            if (!this.unblock && estMdpActuel) {
                this.unblock = this.props.history.block("Vous n'avez pas changé de mot de passe.<br>Voulez-vous vraiment quitter cette page ?");
            }
        });
    };

    FormulaireVerifier = () => (
        <React.Fragment>
            <div className="alert alert-primary" role="alert">
                <i className="fas fa-info-circle" /> Afin de confirmer votre intention, merci de bien vouloir saisir
                votre <b>mot de passe actuel</b> dans le champ suivant.
            </div>
            <Form onSubmit={this.VerifierValidation}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <div className="form-group required">
                            <label htmlFor="Mdp">Mot de passe actuel</label>
                            <Texte
                                field="Mdp"
                                id="Mdp"
                                placeholder="Mot de passe actuel"
                                type="password"
                                refRef={this.inputMdpActuel}
                            />
                            <div className="invalid-feedback">Le mot de passe est incorrect</div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="btn btn-lg btn-success" ref={this.boutonSuivant}>
                                Passer à l&apos;étape suivante
                            </button>
                        </div>
                    </form>
                )}
            </Form>
        </React.Fragment>
    );

    ModifierValidation = (submittedValues) => {
        const { NouveauMdp, ConfirmationMdp } = submittedValues;
        const { MdpActuel } = this.state;
        this.boutonSuivant.current.disabled = true;

        const nouveauMdpOk = estMotdePasseValide(NouveauMdp) && NouveauMdp !== MdpActuel;
        AfficherFeedback(this.inputNouveauMdp, nouveauMdpOk);

        const confirmationMdpOk = NouveauMdp === ConfirmationMdp;
        AfficherFeedback(this.inputConfirmationMdp, confirmationMdpOk);

        if (!nouveauMdpOk || !confirmationMdpOk) {
            this.boutonSuivant.current.disabled = false;
            return;
        }

        modifierMdp(MdpActuel, NouveauMdp).then((changementOk) => {
            if (changementOk) {
                swal('Félicitation !', 'Votre mot de passe a été changé avec succès.', 'success');
                if (this.unblock) this.unblock();
                this.props.history.push('/');
            } else {
                swal('Erreur', 'Le changement de mot de passe a echoué.', 'error');
                this.boutonSuivant.current.disabled = false;
            }
        });
    };

    FormulaireModifier = () => (
        <React.Fragment>
            <div className="alert alert-primary" role="alert">
                <i className="fas fa-info-circle" /> Merci de bien vouloir saisir votre <b>nouveau mot de passe</b>.
            </div>
            <Form onSubmit={this.ModifierValidation}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <div className="form-group required">
                            <label htmlFor="NouveauMdp">Nouveau mot de passe</label>
                            <Texte
                                field="NouveauMdp"
                                id="NouveauMdp"
                                placeholder="Nouveau mot de passe"
                                type="password"
                                refRef={this.inputNouveauMdp}
                            />
                            <div className="invalid-feedback">
                                Le mot de passe doit être différent de l&apos;ancien et la taille doit être comprise
                                entre {MDP_TAILLE_MIN} et {MDP_TAILLE_MAX} caractères
                            </div>
                        </div>
                        <div className="form-group required">
                            <label htmlFor="ConfirmationMdp">Confirmation mot de passe</label>
                            <Texte
                                field="ConfirmationMdp"
                                id="ConfirmationMdp"
                                placeholder="Confirmation mot de passe"
                                type="password"
                                refRef={this.inputConfirmationMdp}
                            />
                            <div className="invalid-feedback">Le mot de passe ne correspond pas</div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="btn btn-lg btn-success" ref={this.boutonSuivant}>
                                Valider le changement
                            </button>
                        </div>
                    </form>
                )}
            </Form>
        </React.Fragment>
    );

    render() {
        const Formulaire = this.state.peutModifier ? <this.FormulaireModifier /> : <this.FormulaireVerifier />;

        return (
            <div className="container col-xl-4">
                <Card Titre="Changer de mot de passe">{Formulaire}</Card>
            </div>
        );
    }
}
PageChangerMdp.displayName = 'PageChangerMdp';

export default PageChangerMdp;



// WEBPACK FOOTER //
// ./src/components/App/PageChangerMdp.js